/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BehavioralAssessmentCto } from '../../models/behavioral-assessment-cto';

export interface GetBehavioralAssessments$Json$Params {
  Email?: string;
  Domain?: string;
  FirstName?: string;
  LastName?: string;
  BSID?: string;
  CompanyGuid?: string;
  CompanyId?: number;
  SessionGuid?: string;
  PersonGuid?: string;
}

export function getBehavioralAssessments$Json(http: HttpClient, rootUrl: string, params?: GetBehavioralAssessments$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BehavioralAssessmentCto>>> {
  const rb = new RequestBuilder(rootUrl, getBehavioralAssessments$Json.PATH, 'get');
  if (params) {
    rb.query('Email', params.Email, {});
    rb.query('Domain', params.Domain, {});
    rb.query('FirstName', params.FirstName, {});
    rb.query('LastName', params.LastName, {});
    rb.query('BSID', params.BSID, {});
    rb.query('CompanyGuid', params.CompanyGuid, {});
    rb.query('CompanyId', params.CompanyId, {});
    rb.query('SessionGuid', params.SessionGuid, {});
    rb.query('PersonGuid', params.PersonGuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BehavioralAssessmentCto>>;
    })
  );
}

getBehavioralAssessments$Json.PATH = '/behavioralAssessment/search';
